import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'py-delete-button',
  templateUrl: './delete-button.component.html',
  styleUrls: ['./delete-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DeleteButtonComponent implements OnInit {
  @Output() confirmDeletion = new EventEmitter<void>();

  @Input() popoverPlacement: string[] = ['bottom', 'top', 'left-bottom', 'left-top', 'top-left'];

  constructor() {}

  ngOnInit(): void {}
}
